@if (formGroup) {
  <div>
    <form [formGroup]="formGroup" novalidate (ngSubmit)="onSubmit()">
      <mat-card class="shipping-card">
        <mat-card-content>
          @for (info of informations; track info) {
            <div>
              @if (info.type === 'title') {
                <mat-card-title>{{
                  info['display_' + locale]
                }}</mat-card-title>
              }
              @if (info.type === 'string') {
                <div class="row flex">
                  <div class="col flex-50">
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>{{ info['display_' + locale] }}</mat-label>
                      <input
                        matInput
                        formControlName="{{ info.fieldName }}"
                        />
                    </mat-form-field>
                  </div>
                  @if (helptexts) {
                    <div class="helptext flex-50">
                      <mat-icon>info_outlined</mat-icon>
                      <div [innerHtml]="helptexts[info.fieldName]"></div>
                    </div>
                  }
                </div>
              }
              @if (info.type === 'email') {
                <div class="row">
                  <div class="col flex-50">
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>{{ info['display_' + locale] }}</mat-label>
                      <input
                        matInput
                        type="email"
                        formControlName="{{ info.fieldName }}"
                        />
                    </mat-form-field>
                  </div>
                  @if (helptexts) {
                    <div class="helptext flex-50">
                      <mat-icon>info_outlined</mat-icon>
                      <div [innerHtml]="helptexts[info.fieldName]"></div>
                    </div>
                  }
                </div>
              }
              @if (info.type === 'password') {
                <div class="row">
                  <div class="col flex-50">
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>{{ info['display_' + locale] }}</mat-label>
                      <input
                        matInput
                        type="password"
                        formControlName="{{ info.fieldName }}"
                        />
                    </mat-form-field>
                  </div>
                  @if (helptexts) {
                    <div class="helptext flex-50">
                      <mat-icon>info_outlined</mat-icon>
                      <div [innerHtml]="helptexts[info.fieldName]"></div>
                    </div>
                  }
                </div>
              }
              @if (info.type === 'textarea') {
                <div class="row">
                  <div class="col flex-50">
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>{{ info['display_' + locale] }}</mat-label>
                      <textarea
                        matInput
                        formControlName="{{ info.fieldName }}"
                      ></textarea>
                    </mat-form-field>
                  </div>
                  @if (helptexts) {
                    <div class="helptext flex-50">
                      <mat-icon>info_outlined</mat-icon>
                      <div [innerHtml]="helptexts[info.fieldName]"></div>
                    </div>
                  }
                </div>
              }
              @if (info.type === 'number') {
                <div class="row">
                  <div class="col flex-50">
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>{{ info['display_' + locale] }}</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="{{ info.fieldName }}"
                        />
                    </mat-form-field>
                  </div>
                  @if (helptexts) {
                    <div class="helptext flex-50">
                      <mat-icon>info_outlined</mat-icon>
                      <div [innerHtml]="helptexts[info.fieldName]"></div>
                    </div>
                  }
                </div>
              }
              @if (info.type === 'boolean') {
                <div class="row">
                  <div class="col flex-50">
                    <mat-checkbox formControlName="{{ info.fieldName }}">{{
                      info['display_' + locale]
                    }}</mat-checkbox>
                  </div>
                  @if (helptexts) {
                    <div class="helptext flex-50">
                      <mat-icon>info_outlined</mat-icon>
                      <div [innerHtml]="helptexts[info.fieldName]"></div>
                    </div>
                  }
                </div>
              }
              @if (info.type === 'date') {
                <div class="row">
                  <mat-form-field appearance="fill">
                    <mat-label>{{ info['display_' + locale] }}</mat-label>
                    <input
                      matInput
                      formControlName="{{ info.fieldName }}"
                      [matDatepicker]="picker"
                      />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              }
              @if (info.type === 'dropdown') {
                <div class="row flex-50">
                  <div class="flex-51">
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>{{info['display_' + locale]}}</mat-label>
                      @if (data[info.fieldName] !== null) {
                        <mat-select [formControlName]="info.fieldName"
                          [value]="data[info.fieldName].id">
                          @for (option of info.options; track option) {
                            <mat-option [value]="option.value">{{option.viewValue}}</mat-option>
                          }
                        </mat-select>
                      }
                      @if (data[info.fieldName] === null) {
                        <mat-select
                          [formControlName]="info.fieldName"
                          >
                          @for (option of info.options; track option) {
                            <mat-option
                              [value]="option.value"
                              >{{ option.viewValue }}</mat-option
                              >
                            }
                          </mat-select>
                        }
                      </mat-form-field>
                    </div>
                    @if (helptexts) {
                      <div class="helptext flex-50 mw-40">
                        <mat-icon>info_outlined</mat-icon>
                        <div [innerHtml]="helptexts[info.fieldName]"></div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </mat-card-content>
          <mat-card-actions>
            @if (showButton) {
              <button
                mat-raised-button
                color="primary"
                [disabled]="!hasChangedForm || !formGroup.valid"
                type="submit"
                i18n="submit@@submit"
                >
          Submit
        </button>
            }
            @if (showCancelButton) {
              <button
                mat-raised-button
                color="accent"
                type="button"
                (click)="cancel()"
                i18n="cancel@@cancel"
                >
          Cancel
        </button>
            }
            @if (showDelete) {
              <button
                mat-raised-button
                color="warn"
                type="button"
                (click)="deleteEvent(formGroup)"
                i18n="delete@@delete"
                >
          Delete
        </button>
            }
          </mat-card-actions>
        </mat-card>
      </form>
    </div>
  }
  @if (!formGroup) {
    <div>No form detected</div>
  }
